import Main from "../../../layouts/Isolated.vue";
import workflow from "./workflow";
import AgencyRegistration from "../views/AgencyRegistration.vue";
import AgencyShell from "../../../layouts/AgencyShell.vue";

export default [
  {
    path: "/register",
    name: "registrationModule",
    component: Main,
    children: workflow
  },
  {
    path: "/",
    name: "agencyShell",
    component: AgencyShell,
    children: [
      {
        path: "/agency/register",
        name: "AgencyRegistration",
        component: AgencyRegistration,
        title: "Career Center Registration",
        meta: {
          allowGuest: true
        }
      }
    ]
  }
];
